import qs from "qs";
import { CustomAxiosRequestConfig } from "@/api";

// 声明一个 Map 用于存储每个请求的标识和取消函数
const pendingMap = new Map<string, AbortController>();

// 序列化参数，确保对象属性顺序一致
const sortedStringify = (obj: unknown) => {
    return qs.stringify(obj, { arrayFormat: "repeat", sort: (a, b) => a.localeCompare(b) });
};

// 获取请求的唯一标识
export const getPendingUrl = (config: CustomAxiosRequestConfig) => {
    return [config.method, config.url, sortedStringify(config.data), sortedStringify(config.params)].join("&");
};

const keywords = ["get-unread-message", "file/ids"];

export class AxiosCanceler {
    /**
     * @description: 添加请求
     * @param {Object} config
     * @return void
     */
    addPending(config: CustomAxiosRequestConfig) {
        const url = getPendingUrl(config);
        // 如果已存在相同url的controller，取消新请求
        if (pendingMap.has(url) && config.method !== "get" && !keywords.some(keyword => config.url?.includes(keyword))) {
            const controller = new AbortController();
            controller.abort(); // 取消新请求
            config.signal = controller.signal;
        } else {
            const controller = new AbortController();
            config.signal = controller.signal;
            pendingMap.set(url, controller);
        }
        setTimeout(() => pendingMap.delete(url), 500);
    }

    /**
     * @description: 移除请求
     * @param {Object} config
     */
    removePending(config: CustomAxiosRequestConfig) {
        const url = getPendingUrl(config);
        this.abortPending(config);
        pendingMap.delete(url);
    }

    /**
     * @description: 取消请求
     * @param {Object} config
     */
    abortPending(config: CustomAxiosRequestConfig) {
        const url = getPendingUrl(config);
        // 如果在 pending 中存在当前请求标识，需要取消当前请求并删除条目
        const controller = pendingMap.get(url);
        if (controller) {
            controller.abort();
        }
    }
}
